export default "__VITE_ASSET__CwMQzFjv__"